import { useBulkDonorScheduleStore } from '../../hooks/use-bulk-donor-schedule-store';
import type { AgllcBulkDonorScheduleInput } from '../utils/schema';

export function useAgllcBulkDonorScheduleStore() {
  return useBulkDonorScheduleStore<AgllcBulkDonorScheduleInput>();
}
